import axios from 'axios'
import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from '../../urlLink'
const root = Urls.crmApiUrl //域名
//首页数据请求
const url = {
 getAudition:root+"/Clientinvite/getAuditionApi",
 getAuditionStaffer:root+"/Clientinvite/getAuditionStafferApi",
}
const storeClass =  {
  // 获取教师
  getAuditionStaffer(params){
    return axios.get(url.getAuditionStaffer,{ params })
  },
//   试听跟进->获取试听班级
  getAudition(params){
    return axios.get(url.getAudition,{ params })
  },
  // 招生目标线索->绑定学员
  bindingClient(params){
    return axios.post(url.bindingClient,qs.stringify(params))
  },
}

export default storeClass;